import type { ReactElement } from 'react';

import { Box, Flex, Progress, Skeleton, Text } from '@rango-dev/whale';
import { CircleStar } from 'lucide-react';
import React, { useEffect, useState } from 'react';

import { useAppSelector } from '../../../hooks/reduxHooks';
import { displayUserRank } from '../ProfileSummary/ProfileSummary.helpers';

const MIN_VISIBLE_PROGRESS = 3;
const PROGRESS_ANIMATION_DELAY_MS = 500;

export function UserScoreProgress(): ReactElement {
  const [progress, setProgress] = useState(0);
  const { data: profileSummary, loading } = useAppSelector(
    (state) => state.profile.profileSummary.private,
  );

  useEffect(() => {
    if (profileSummary) {
      const levelProgress =
        profileSummary.levelProgress === 0 ? MIN_VISIBLE_PROGRESS : profileSummary.levelProgress;
      const timeout = setTimeout(() => {
        setProgress(levelProgress);
      }, PROGRESS_ANIMATION_DELAY_MS);
      return () => clearTimeout(timeout);
    }
  }, [profileSummary?.levelProgress]);

  return (
    <Flex direction="column" gap="1" width="100%">
      {loading ? (
        <Skeleton width="100%" height="8px" />
      ) : (
        <Progress value={progress} size="2" color="cyan" />
      )}

      <Flex justify="between" align="center">
        {loading ? (
          <>
            <Skeleton width="60px" height="20px" />
            <Skeleton width="60px" height="20px" />
          </>
        ) : (
          <>
            <Text size={{ initial: '1', sm: '2' }} weight="medium">
              Lvl - {profileSummary?.level.level}
            </Text>
            <Flex align="center" gap="1">
              <Box
                width={{
                  initial: '16px',
                  sm: '24px',
                }}>
                <CircleStar color="gray" width="100%" height="auto" />
              </Box>
              {profileSummary && (
                <Text size={{ initial: '1', sm: '2' }} weight="medium" color="gray">
                  {displayUserRank(profileSummary.score)} / {profileSummary.level.to}
                </Text>
              )}
            </Flex>
          </>
        )}
      </Flex>
    </Flex>
  );
}
